var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-card",on:{"click":_vm.goDetail}},[_c('img',{attrs:{"src":_vm.image.logo,"alt":"图片"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }